export default {
  methods: {
    replaceFancyText(text, classBlock = null) {
      if (!text || typeof text !== 'string') return text;

      const regex = /UConnect\s?/gi;
      const className = classBlock ? `${classBlock}__fancy-text` : 'fancy-text';

      return text.replace(regex, (match) => `<span class="${className}">${match}</span>`);
    },
  },
};
